var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystrategyWordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 415.359 110.745",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -86.321953, -9.377801)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.8,78.2c-1.1-0.7-2.1-1.6-2.8-2.8s-1-2.4-1-3.7v-0.9h6.3v0.7c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4h18.8 c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V67c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.4-1-0.4h-19c-1.4,0-2.6-0.3-3.7-1 c-1.1-0.7-2.1-1.6-2.8-2.7s-1-2.4-1-3.8v-4.9c0-1.4,0.3-2.6,1-3.7s1.6-2.1,2.8-2.8c1.1-0.7,2.4-1,3.7-1h19.1c1.4,0,2.7,0.3,3.8,1 c1.1,0.7,2,1.6,2.7,2.8c0.7,1.1,1,2.4,1,3.7V54h-6.3v-0.7c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.4-1-0.4h-18.8c-0.4,0-0.7,0.1-1,0.4 s-0.4,0.6-0.4,1v4.5c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4h19c1.4,0,2.7,0.3,3.8,1s2,1.6,2.7,2.7c0.7,1.1,1,2.4,1,3.8v4.9 c0,1.4-0.3,2.6-1,3.7c-0.7,1.1-1.6,2.1-2.7,2.8s-2.4,1-3.8,1h-19.1C122.1,79.3,120.9,78.9,119.8,78.2z",
    style: {
      fill: "rgb(23, 77, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.4,92.1v-6.3H182c0.4,0,0.7-0.1,1-0.4s0.4-0.6,0.4-1v-5.1H163c-1.4,0-2.6-0.3-3.8-1s-2.1-1.6-2.8-2.8 c-0.7-1.1-1-2.4-1-3.7v-26h6.3v25.8c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4H182c0.4,0,0.7-0.1,1-0.4s0.4-0.6,0.4-1V45.7h6.3v38.9 c0,1.4-0.3,2.7-1,3.8s-1.6,2-2.7,2.7c-1.1,0.7-2.4,1-3.8,1H161.4z",
    style: {
      fill: "rgb(23, 77, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199,78.2c-1.1-0.7-2.1-1.6-2.8-2.8s-1-2.4-1-3.7v-0.9h6.3v0.7c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4h18.8 c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V67c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.4-1-0.4h-19c-1.4,0-2.6-0.3-3.7-1 c-1.1-0.7-2.1-1.6-2.8-2.7s-1-2.4-1-3.8v-4.9c0-1.4,0.3-2.6,1-3.7s1.6-2.1,2.8-2.8c1.1-0.7,2.4-1,3.7-1h19.1c1.4,0,2.7,0.3,3.8,1 c1.1,0.7,2,1.6,2.7,2.8c0.7,1.1,1,2.4,1,3.7V54h-6.3v-0.7c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.6-0.4-1-0.4h-18.8c-0.4,0-0.7,0.1-1,0.4 s-0.4,0.6-0.4,1v4.5c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4h19c1.4,0,2.7,0.3,3.8,1s2,1.6,2.7,2.7c0.7,1.1,1,2.4,1,3.8v4.9 c0,1.4-0.3,2.6-1,3.7c-0.7,1.1-1.6,2.1-2.7,2.8s-2.4,1-3.8,1h-19.1C201.4,79.3,200.2,78.9,199,78.2z",
    style: {
      fill: "rgb(23, 77, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.8,78.2c-1.1-0.7-2.1-1.6-2.7-2.8c-0.7-1.1-1-2.4-1-3.7V35h6.3v10.6h13.8v6.3h-13.8v19.7 c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4h12.4v6.3h-12.5C241.2,79.3,239.9,78.9,238.8,78.2z",
    style: {
      fill: "rgb(130, 142, 193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.1,79.3V53.2c0-1.4,0.3-2.6,1-3.7c0.7-1.1,1.6-2.1,2.8-2.8c1.1-0.7,2.4-1,3.7-1h18.8v6.3h-18.6 c-0.4,0-0.7,0.1-1,0.4s-0.4,0.6-0.4,1v25.9H260.1z",
    style: {
      fill: "rgb(130, 142, 193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.4,79.3c-1.4,0-2.7-0.3-3.8-1s-2-1.6-2.7-2.8c-0.7-1.1-1-2.4-1-3.7V59.3h27.9v-6c0-0.4-0.1-0.7-0.4-1 s-0.6-0.4-1-0.4h-26.5v-6.3h26.7c1.4,0,2.7,0.3,3.8,1c1.1,0.7,2,1.6,2.7,2.8s1,2.4,1,3.7v26.1H298.4z M298.6,73h20.2v-7.8h-21.6 v6.4c0,0.4,0.1,0.7,0.4,1S298.2,73,298.6,73z",
    style: {
      fill: "rgb(130, 142, 193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.6,78.2c-1.1-0.7-2.1-1.6-2.7-2.8c-0.7-1.1-1-2.4-1-3.7V35h6.3v10.6h13.8v6.3h-13.8v19.7 c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4h12.4v6.3h-12.5C337,79.3,335.7,78.9,334.6,78.2z",
    style: {
      fill: "rgb(130, 142, 193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.6,78.2c-1.1-0.7-2.1-1.6-2.8-2.8s-1-2.4-1-3.7V53.2c0-1.4,0.3-2.6,1-3.7s1.6-2.1,2.8-2.8 c1.1-0.7,2.4-1,3.7-1h19.1c1.4,0,2.7,0.3,3.8,1c1.1,0.7,2,1.6,2.7,2.8c0.7,1.1,1,2.4,1,3.7v12.4h-28v6c0,0.4,0.1,0.7,0.4,1 s0.6,0.4,1,0.4h26.5v6.3h-26.7C362,79.3,360.8,78.9,359.6,78.2z M362.1,59.7h21.6v-6.4c0-0.4-0.1-0.7-0.4-1 c-0.3-0.3-0.6-0.4-1-0.4h-18.8c-0.4,0-0.7,0.1-1,0.4s-0.4,0.6-0.4,1V59.7z",
    style: {
      fill: "rgb(130, 142, 193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.3,92.5v-6.3h20.6c0.4,0,0.7-0.1,1-0.4s0.4-0.6,0.4-1v-5.5h-20.4c-1.4,0-2.6-0.3-3.8-1 c-1.2-0.7-2.1-1.6-2.8-2.8s-1-2.4-1-3.7V53.2c0-1.4,0.3-2.6,1-3.7s1.6-2.1,2.8-2.8c1.1-0.7,2.4-1,3.7-1h19.1c1.4,0,2.7,0.3,3.8,1 c1.1,0.7,2,1.6,2.7,2.8c0.7,1.1,1,2.4,1,3.7V85c0,1.4-0.3,2.7-1,3.8c-0.7,1.1-1.6,2-2.7,2.7c-1.1,0.7-2.4,1-3.8,1H401.3z  M403.1,73h18.8c0.4,0,0.7-0.1,1-0.4s0.4-0.6,0.4-1V53.3c0-0.4-0.1-0.7-0.4-1s-0.6-0.4-1-0.4h-18.8c-0.4,0-0.7,0.1-1,0.4 s-0.4,0.6-0.4,1v18.2c0,0.4,0.1,0.7,0.4,1S402.7,73,403.1,73z",
    style: {
      fill: "rgb(130, 142, 193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441,92.1v-6.3h20.6c0.4,0,0.7-0.1,1-0.4s0.4-0.6,0.4-1v-5.1h-20.4c-1.4,0-2.6-0.3-3.8-1s-2.1-1.6-2.8-2.8 c-0.7-1.1-1-2.4-1-3.7v-26h6.3v25.8c0,0.4,0.1,0.7,0.4,1s0.6,0.4,1,0.4h18.8c0.4,0,0.7-0.1,1-0.4s0.4-0.6,0.4-1V45.7h6.3v38.9 c0,1.4-0.3,2.7-1,3.8s-1.6,2-2.7,2.7c-1.1,0.7-2.4,1-3.8,1H441z",
    style: {
      fill: "rgb(130, 142, 193)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystrategyWordLogo);
export default __webpack_public_path__ + "static/media/systrategy_word_logo.8e7bcf6d4a78b1e2e1421ca6ed33fcfd.svg";
export { ForwardRef as ReactComponent };